var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { CaseStatus } from '@debbie/common/dist/cases';
import { c, h } from '@debbie/cortex/dist';
import Textarea from '../../Textarea';
import DateInput from '../../DateInput';
import Checkbox from '../../Checkbox';
import FilterGroup from '../FilterGroup';
import FilterOption from '../FilterOption';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons';
import { objectBy } from '@debbie/common/dist/util';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups';
let tid = null;
const CasesGroup = (props) => {
    const { caseFilter } = props;
    const endReasons = useEndReasons();
    const endReasonLookup = h.hasData(endReasons)
        ? objectBy(endReasons.data, (er) => er.id)
        : {};
    const lang = useSelector((s) => s.lang);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const [caseSeqIdValue, setCaseSeqIdValue] = useState('');
    return (React.createElement(FilterGroup, { name: lang.caseFilter.casesGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.caseStatuses && caseFilter.caseStatuses.length), header: lang.caseFilter.caseStatus, onDeactivate: () => c.insights.clearFilter('caseStatuses') },
            React.createElement(Select, { value: (caseFilter.caseStatuses || []).map((status) => ({
                    label: lang.cases[status],
                    value: status,
                })), isMulti: true, placeholder: lang.caseFilter.selectCaseStatus, classNamePrefix: "select", options: Object.values(CaseStatus).map((status) => ({
                    label: lang.cases[status],
                    value: status,
                })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        caseStatuses: selected,
                    });
                }) })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseEndReasonIds && caseFilter.caseEndReasonIds.length), header: lang.caseFilter.endReasons, onDeactivate: () => c.insights.clearFilter('caseEndReasonIds') },
            React.createElement(Select, { value: (caseFilter.caseEndReasonIds || []).map((endReasonId) => {
                    var _a;
                    return ({
                        label: (_a = lang.endReason[endReasonLookup[endReasonId].handle]) !== null && _a !== void 0 ? _a : endReasonLookup[endReasonId].label,
                        value: endReasonId,
                    });
                }), isMulti: true, placeholder: lang.caseFilter.selectEndReasons, classNamePrefix: "select", options: (h.hasData(endReasons) ? endReasons.data : []).map((reason) => {
                    var _a;
                    return {
                        label: (_a = lang.endReason[reason.handle]) !== null && _a !== void 0 ? _a : reason.label,
                        value: reason.id,
                    };
                }), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        caseEndReasonIds: selected,
                    });
                }) })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseGroups && caseFilter.caseGroups.length), header: lang.caseFilter.caseGroup, onDeactivate: () => c.insights.clearFilter('caseGroups') },
            React.createElement(Select, { value: (caseFilter.caseGroups || []).map((caseGroupId) => {
                    const caseGroup = caseGroups && caseGroups.find((cG) => cG.id === caseGroupId);
                    return {
                        label: (caseGroup && caseGroup.label) || caseGroupId,
                        value: caseGroupId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectCaseGroup, classNamePrefix: "select", options: (caseGroups || []).map((caseGroup) => ({
                    label: caseGroup.label,
                    value: caseGroup.id,
                })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        caseGroups: selected,
                    });
                }) })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseCreationDate && caseFilter.caseCreationDate.from), header: lang.caseFilter.caseCreatedAfter, onDeactivate: () => c.insights.clearFilter('caseCreationDate', true, 'from') },
            React.createElement(DateInput, { allowNull: true, style: { marginBottom: '0' }, value: (caseFilter.caseCreationDate &&
                    caseFilter.caseCreationDate.from &&
                    moment(caseFilter.caseCreationDate.from)) ||
                    undefined, onChange: (e) => c.insights.updateFilter({
                    caseCreationDate: Object.assign(Object.assign({}, caseFilter.caseCreationDate), { from: e.format() }),
                }), placeholder: lang.caseFilter.caseCreatedAfterPlaceholder })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseCreationDate && caseFilter.caseCreationDate.to), header: lang.caseFilter.caseCreatedBefore, onDeactivate: () => c.insights.clearFilter('caseCreationDate', true, 'to') },
            React.createElement(DateInput, { allowNull: true, style: { marginBottom: '0' }, value: (caseFilter.caseCreationDate &&
                    caseFilter.caseCreationDate.to &&
                    moment(caseFilter.caseCreationDate.to)) ||
                    undefined, onChange: (e) => c.insights.updateFilter({
                    caseCreationDate: Object.assign(Object.assign({}, caseFilter.caseCreationDate), { to: e.format() }),
                }), placeholder: lang.caseFilter.caseCreatedBeforePlaceholder })),
        React.createElement(FilterOption, { active: !!caseFilter.caseSeqIds, header: lang.caseFilter.caseSeqIds, onDeactivate: () => {
                c.insights.clearFilter('caseSeqIds');
                c.insights.clearFilter('exceptCaseSeqIds');
                setCaseSeqIdValue('');
            } },
            React.createElement("p", null, lang.caseFilter.caseSeqIdsDescription),
            React.createElement(Textarea, { value: caseSeqIdValue, style: { height: '150px' }, onChange: (e) => {
                    const val = e.target.value;
                    setCaseSeqIdValue(val);
                    if (tid)
                        clearTimeout(tid);
                    tid = setTimeout(() => {
                        const ids = val
                            .split(/[ ,;\n]+/)
                            .map((id) => id.trim())
                            .filter((id) => id && !isNaN(parseInt(id)))
                            .map((id) => parseInt(id));
                        c.insights.updateFilter({
                            caseSeqIds: ids.length ? ids : undefined,
                        });
                    }, 500);
                }, placeholder: lang.caseFilter.caseSeqIds }),
            React.createElement(Checkbox, { checked: !!caseFilter.exceptCaseSeqIds, onChange: (e) => {
                    const val = e.target.checked;
                    c.insights.updateFilter({
                        exceptCaseSeqIds: val || undefined,
                    });
                }, placeholder: lang.caseFilter.exceptCaseSeqIds }))));
};
export default CasesGroup;
//# sourceMappingURL=CasesGroup.js.map